import ReturnOrdersApi from '@/API/return-orders-api'

export default {
  namespaced: true,
  state: {
    fetched: false,
    noOrders: false,
  },

  getters: {
    noOrders: (state: any) => state.noOrders,
  },

  mutations: {
    SET_DATA(state: any, payload: any) {
      state.noOrders = payload.noOrders ?? false
    },
  },

  actions: {
    async FETCH_DEPENDENCIES(context: any) {
      if (context.state.fetched) {
        return
      }
      try {
        const branchId = context.rootGetters['branches/currentBranchId']
        const data = await ReturnOrdersApi.getSettings(branchId)
        context.commit('SET_DATA', data)
      } catch (err) {
        console.error(err)
      }
    },
  },
}
